import request from '@/axios'

// 新建需求评测
export function demandeEvaluatingAdd(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/evaluating/demandeEvaluatingAdd',
    method: 'post',
    data
  })
}

// 用户测评信息
export function userInfoEvaluating(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/evaluating/userInfoEvaluating',
    method: 'post',
    data
  })
}

// 用户测评报告
export function userEvaluatingReport(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/evaluating/userEvaluatingReport',
    method: 'post',
    data
  })
}

// 设计方案
export function designScheme(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/evaluating/designScheme',
    method: 'post',
    data
  })
}

// 用户需求评测信息
export function evaluatingInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/evaluating/evaluatingInfo',
    method: 'post',
    data
  })
}

// 用户群信息
export function userFlockInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/evaluating/userFlockInfo',
    method: 'post',
    data
  })
}

// v-1.2.0-07-获取RAD客户信息
export function getRadCustomerInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/evaluating/getRadCustomerInfo',
    method: 'post',
    data
  })
}

// v-1.2.0-07-获取微信客户信息
export function getWxUserInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/evaluating/getWxUserInfo',
    method: 'post',
    data
  })
}

// v-1.2.0-08-保存客户服务人员
export function saveServiceUser(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/evaluating/saveServiceUser',
    method: 'post',
    data
  })
}

// v-1.2.0-09-获取客户服务人员
export function getServiceUserList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/evaluating/getServiceUserList',
    method: 'post',
    data
  })
}
// (rad1)-01-修改邀请函状态
export function saveInviteStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_one/saveInviteStatus',
    method: 'post',
    data
  })
}
